import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import OpenAccountPage from "./pages/OpenAccountPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import KVKKPage from "./pages/KVKKPage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/hizmetler" element={<ServicesPage />} />
          <Route path="/hizmetler/:serviceId" element={<ServiceDetailPage />} />
          <Route path="/hakkimizda" element={<AboutPage />} />
          <Route path="/iletisim" element={<ContactPage />} />
          <Route path="/hesap-ac" element={<OpenAccountPage />} />
          <Route path="/gizlilik" element={<PrivacyPolicyPage />} />
          <Route path="/kvkk" element={<KVKKPage />} />
          <Route path="/cerez" element={<CookiePolicyPage />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
